import React from 'react';
import Link from 'next/link';
import {Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger} from '@/components/ui/dialog';
import {Separator} from '@/components/ui/separator';
import {Button} from '@/components/ui/button';
import {Typography} from '@/components/ui/typography';

type TrialModalProps = {
    onClose: () => void;
    open: boolean;
    onActivateTrailClick: () => void;
}
export const TrialModal = ({onClose, open, onActivateTrailClick}: TrialModalProps) => {
    return (
        <Dialog open={open} onOpenChange={(state) => {
            if (state === false) {
                onClose()
            }
        }}>
            <DialogContent className="sm:max-w-[425px] bg-backgroundBrand">
                <DialogHeader>
                    <DialogTitle>Ready to activate your 14-day trial now?</DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <Typography>
                        Enjoy full Challenger plan functionallity free for 14 days.
                    </Typography>
                    <Typography>
                        Once started you cannot pause or cancel it. During the trial, you can select your membership plan and provide your credit card details. The first payment will be debited and your selected plan will be active after the free 14 days are over.
                    </Typography>
                </div>
                <DialogFooter>
                    <Button
                        variant="secondary"
                        onClick={onClose}

                    >
                        No, not now
                    </Button>
                    <Button
                        onClick={onActivateTrailClick}

                    >Activate 14-day trial</Button>
                </DialogFooter>
                <Separator />
                <div className="text-muted-foreground text-sm">
                    Check all pricing plans on
                    {' '}
                    <Link href="/pricing">
                        <a className="link-primary">Pricing page</a>
                    </Link>
                    .
                </div>
            </DialogContent>
        </Dialog>
    )
}
